module.exports = __webpack_public_path__ + "static/img/ITDP5.b39fe40.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/schoolEnrollment/ITDP5.jpg
// module id = LNNk
// module chunks = 1